import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/partners/companies/")({
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["customer.view_company"])) {
      throw redirect({ to: "/" })
    }
    throw redirect({
      to: "/partners/companies/manage",
      replace: true,
    })
  },
})
